import { replaceDoubleSpaceToSingle } from 'utils';
import { maskPhoneNum } from 'utils';

const updateState = (emergencyContacts, updatedContact, internalStateSetter, outlet) => {
    internalStateSetter({ emergencyContact: updatedContact })

    const updatedContacts = emergencyContacts.map((item) => {
        if (item.id === updatedContact.id) return updatedContact;
        return item
    })

    outlet({ emergencyContacts: updatedContacts })
}

export default {
    'EmergencyContact.Name': ({ emergencyContacts, emergencyContact, value }, outlet, internalStateSetter) => {
        const updatedContact = { ...emergencyContact, name: replaceDoubleSpaceToSingle(value), nameError: '', hasError: false }
        updateState(emergencyContacts, updatedContact, internalStateSetter, outlet)
    },
    'EmergencyContact.PhoneNumber': ({ emergencyContacts, emergencyContact, value }, outlet, internalStateSetter) => {

        const maskedNum = maskPhoneNum(value)
        const updatedContact = { ...emergencyContact, phoneNumber: maskedNum, phoneNumberError: '', hasError: false }
        updateState(emergencyContacts, updatedContact, internalStateSetter, outlet)
    },
    'EmergencyContact.Email': ({ emergencyContacts, emergencyContact, value }, outlet, internalStateSetter) => {
        const updatedContact = { ...emergencyContact, email: value, emailError: '', hasError: false }
        updateState(emergencyContacts, updatedContact, internalStateSetter, outlet)
    },
    'EmergencyContact.Relationship': ({ emergencyContacts, emergencyContact, value }, outlet, internalStateSetter) => {
        const updatedContact = { ...emergencyContact, relationship: value, relationshipError: '', hasError: false }
        updateState(emergencyContacts, updatedContact, internalStateSetter, outlet)
    },
    'EmergencyContact.DeleteButton': ({ resourceList: emergencyContacts, id }, outlet) => {
        const filteredEmergencyContacts = emergencyContacts.filter((contact) => contact.id !== id)
        outlet({ emergencyContacts: filteredEmergencyContacts })
    },
};
